import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

/**
 * Instância global do router TanStack.
 * A routeTree é gerada automaticamente pelo plugin Vite ao rodar `yarn dev`.
 */
export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
